var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "#F2F0F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2149_1652",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 20,
    height: 20
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "#FCFCFC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2149_1652)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 18.75,
    width: 13.75,
    height: 2.5,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 18.75,
    width: 13.75,
    height: 2.5,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 13.75,
    width: 19.75,
    height: 2.5,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 13.75,
    width: 19.75,
    height: 2.5,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 8.5,
    width: 19.75,
    height: 2.5,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 8.5,
    width: 19.75,
    height: 2.5,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 3.5,
    width: 19.75,
    height: 2.5,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 3.5,
    width: 19.75,
    height: 2.5,
    fill: "#D90026"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 10.25,
    height: 10,
    fill: "#0052B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 9.375L8.5 9.75L8.75 9L8.25 8.5H9L9.25 7.75L9.625 8.5H10.25L9.75 9L10 9.75L9.25 9.375Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 9.375L5 9.75L5.25 9L4.75 8.5H5.5L5.75 7.75L6.125 8.5H6.75L6.25 9L6.5 9.75L5.75 9.375Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 9.375L1.5 9.75L1.75 9L1.25 8.5H2L2.25 7.75L2.625 8.5H3.25L2.75 9L3 9.75L2.25 9.375Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 6.625L8.5 7L8.75 6.25L8.25 5.75H9L9.25 5L9.625 5.75H10.25L9.75 6.25L10 7L9.25 6.625Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 3.875L8.5 4.25L8.75 3.5L8.25 3H9L9.25 2.25L9.625 3H10.25L9.75 3.5L10 4.25L9.25 3.875Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 1.125L8.5 1.5L8.75 0.75L8.25 0.25H9L9.25 -0.5L9.625 0.25H10.25L9.75 0.75L10 1.5L9.25 1.125Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 3.875L5 4.25L5.25 3.5L4.75 3H5.5L5.75 2.25L6.125 3H6.75L6.25 3.5L6.5 4.25L5.75 3.875Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 6.625L5 7L5.25 6.25L4.75 5.75H5.5L5.75 5L6.125 5.75H6.75L6.25 6.25L6.5 7L5.75 6.625Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 6.625L1.5 7L1.75 6.25L1.25 5.75H2L2.25 5L2.625 5.75H3.25L2.75 6.25L3 7L2.25 6.625Z",
    fill: "#EFEFEF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsFlag);
export default __webpack_public_path__ + "static/media/us-flag.c848b6d9db653505e1608d0840d212a2.svg";
export { ForwardRef as ReactComponent };